/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useCallback } from 'react';
import { AjaxContext } from 'commons-ui';
// import { ISegmentConfigData } from './type';
import { DowntimeManagementConstants } from './constant';

const useService = () => {
	const [isActive, setIsActive] = React.useState<{ id: boolean; label: string }>({ id: true, label: 'TEST' });
	const { postData } = useContext(AjaxContext);

	const requestUpdateConfig = useCallback((appName: string, data: any) => {
		return postData({
			endpoint: DowntimeManagementConstants.UPDATE_CONFIG_URI,
			body: { ...data },
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		requestUpdateConfig,
		isActive,
		setIsActive
	};
};

export default useService;
